import React from 'react';

import { Content, Version } from './styles';
import isMobile from '../../utils/isMobile.util';

type ScrollProps = {
  scrollPosition?: number;
};

const Footer: React.FC<ScrollProps> = ({ scrollPosition }) => {
  return (
    <Content scrollPosition={scrollPosition}>
      <Version>
        <span data-cy="app-version">
          {isMobile() ? 'Mobile | ' : 'Desktop | '}
          {`versão ${process.env.REACT_APP_VERSION as string}`}
        </span>
      </Version>
    </Content>
  );
};

export default Footer;
